/**
 * Checks if a filename is a Flux footprint file
 *
 * This function validates whether a given filename has the Flux footprint
 * file extension (.flx_ftp). It performs case-insensitive validation and
 * handles null or non-string inputs safely.
 *
 * @param value - The filename to check
 * @returns True if the filename has the Flux footprint extension, false otherwise
 *
 * @example
 * // Returns true
 * isFluxFootprintFileName("component.flx_ftp");
 *
 * @example
 * // Returns true (case insensitive)
 * isFluxFootprintFileName("COMPONENT.FLX_FTP");
 *
 * @example
 * // Returns false
 * isFluxFootprintFileName("component.txt");
 */
export default function isFluxFootprintFileName(value: string | null): boolean {
    if (typeof value !== "string") {
        return false;
    }
    return value.toLowerCase().endsWith(".flx_ftp");
}
